export enum FillOutInfoMode {
  JOB = 'JOB',
  JOB_ROUTINE = 'JOB_ROUTINE',
  JOB_ROUTINE_TEMPLATE = 'JOB ROUTINE_TEMPLATE',
  NONE = 'NONE'
}
